import React from 'react';
import "./Project2.scss";
import Fade from 'react-reveal/Fade';


export const Project2 = () => {
  return (
    <div className="project2" id="project2">
      <div className="contaner">
          <h1 >PROJECTS </h1>

      <Fade left>
         <div className="cards">
         <img  style={{height: "100px",width:"250px"}}src="Images/I1.png "/>
       <h2>Travel Advisor
           <p>Build an advanced Travel advisor website using Google Maps. 
           <br/>
             With Geolocation, Google Maps API
             <br/> </p>
          <a href="https://github.com/dipakjagtap29/TravelBea" target="_blank"> <button>VIEW PROJECT</button></a>
          </h2>

           
         </div>
         </Fade >

          <br/>

         <Fade right>
         <div className="sp-cards">
           <img style={{height: "100px",width:"200px"}} src="Images/I2.png"/>
         <h2>NewsDay.io
           <p>news feeding website with multiple news sections like entertainment,
           <br/> Technology, Science, Sports, Business etc</p> 
           <a href="https://github.com/dipakjagtap29/NewsDay.io" target="_blank"><button>VIEW PROJECT</button></a>
           </h2>
         </div>
         </Fade>

        <br/>

         <Fade left>
       <div className="cards">
       <img  style={{height: "100px",width:"200px"}} src="Images/I20.png"/>
           <h2  >PortFolio Website
           <p   >A simple PortFolio website to showcase my achivements,
             <br/> skills and many more</p>
            <a href="https://dipak-jagtap.netlify.app" target="_blank"><button>VIEW PROJECT</button></a>
            </h2>
     
          </div>
         </Fade>

          <br/>

         <Fade right>
         <div className="sp-cards">
           <img style={{height: "100px",width:"200px"}} src="Images/I3.png"/>
         <h2> E-commerce online shopping website
           <p>Developed an e-commerce platform which covers all basic functionalities
           <br/> that a shopping site should have, i.e Creating Accounts, Wishlist,
           <br/>Cart,Session Handling etc.</p>
           <a href="https://github.com/dipakjagtap29/SHOPIFY_MERN_PROJECT" target="_blank"><button>VIEW PROJECT</button></a>
           </h2>
         </div>
         </Fade>

       </div>
       </div>
    
  )
}

export default Project2;
